import axios from '../../utils/AxiosUtils';
import i18n from '../../i18next';
import MessageUtils from "../../utils/MessageUtils";

import {
    LOADING,
    LOAD_JOB_PAYLOAD_SUCCESS,
    CLEAR_PAYLOAD
} from '../types';


export const loadJobPayload = (jobId) => {
    return (dispatch) => {
        dispatch({ type: CLEAR_PAYLOAD, payload: i18n.t('actions:jobPayloadActions.loadingPayload')});
        dispatch({ type: LOADING, payload: true });

        const url = `/job/${jobId}/payload`;

        axios().get(url)
            .then(response => loadJobPayloadSuccess(dispatch, response))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:jobPayloadActions.loadJobPayloadFailure')));
    }
}

const loadJobPayloadSuccess = (dispatch, response) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: LOAD_JOB_PAYLOAD_SUCCESS, payload: response.data });
}



// WEBPACK FOOTER //
// ./src/actions/jobhistory/JobPayloadActions.js